import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchHotelAvailabilitySaga } from "./fetchHotelAvailabilitySaga";
import { fetchViewHotelsNearLocationsSaga } from "./fetchViewHotelsNearSaga";
import { fetchUserHotelPreferencesSaga } from "./fetchUserHotelPreferencesSaga";
import { listPaymentMethodsSaga } from "./listPaymentMethodsSaga";
import { fetchWishlistAvailabilitySaga } from "./fetchWishlistAvailabilitySaga";
import { fetchHasSeenWishlistFtuxSaga } from "./fetchHasSeenWishlistFtuxSaga";
import { updateHasSeenWishlistFtuxSaga } from "./updateHasSeenWishlistFtuxSaga";
import { fetchHasSeenStaysFilterFtuxSaga } from "./fetchHasSeenStaysFilterFtuxSaga";
import { updateHasSeenStaysFilterFtuxSaga } from "./updateHasSeenStaysFilterFtuxSaga";

export function* watchFetchHotelAvailability() {
  yield takeLatest(
    [
      actionTypes.FETCH_INITIAL_HOTEL_AVAILABILITY,
      actionTypes.FETCH_WISHLIST_AVAILABILITY,
    ],
    fetchHotelAvailabilitySaga
  );
  yield takeLatest(
    [
      actionTypes.FETCH_MORE_HOTEL_AVAILABILITY,
      actionTypes.FETCH_WISHLIST_AVAILABILITY,
    ],
    fetchHotelAvailabilitySaga
  );
}

export function* watchFetchWishlistAvailability() {
  yield takeLatest(
    actionTypes.FETCH_WISHLIST_AVAILABILITY,
    fetchWishlistAvailabilitySaga
  );
}

export function* watchFetchViewHotelsNearLocations() {
  yield takeLatest(
    actionTypes.FETCH_VIEW_HOTELS_NEAR_LOCATION_CATEGORIES,
    fetchViewHotelsNearLocationsSaga
  );
}

export function* watchFetchUserHotelPreferences() {
  yield takeLatest(
    actionTypes.FETCH_USER_HOTEL_PREFERENCES,
    fetchUserHotelPreferencesSaga
  );
}

export function* watchListHotelAvailabilityPaymentMethods() {
  yield takeLatest(actionTypes.LIST_PAYMENT_METHODS, listPaymentMethodsSaga);
}

export function* watchFetchHasSeenWishlistFtux() {
  yield takeLatest(
    actionTypes.FETCH_HAS_SEEN_WISHLIST_FTUX,
    fetchHasSeenWishlistFtuxSaga
  );
}

export function* watchUpdateHasSeenWishlistFtux() {
  yield takeLatest(
    actionTypes.UPDATE_HAS_SEEN_WISHLIST_FTUX,
    updateHasSeenWishlistFtuxSaga
  );
}

export function* watchFetchHasSeenStaysFilterFtux() {
  yield takeLatest(
    actionTypes.FETCH_HAS_SEEN_STAYS_FILTER_FTUX,
    fetchHasSeenStaysFilterFtuxSaga
  );
}

export function* watchUpdateHasSeenStaysFilterFtux() {
  yield takeLatest(
    actionTypes.UPDATE_HAS_SEEN_STAYS_FILTER_FTUX,
    updateHasSeenStaysFilterFtuxSaga
  );
}
